export const WES_COACH_MODE_ID = 'WES_CHECKOUT';
export const CONTEXT_CONFIG = {
  config: {
    coachModeId: WES_COACH_MODE_ID,
    coachActionId: 'ASSISTANT',
  },
  additionalContext: [] as [],
  courseraContext: {},
};
